/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Rail_Book_BodyInputs */

const en_portal_rail_book_body = /** @type {(inputs: Portal_Rail_Book_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your coach's open hours, booked in one tap.`)
};

const pl_portal_rail_book_body = /** @type {(inputs: Portal_Rail_Book_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wolne godziny trenera i rezerwacja jednym kliknięciem.`)
};

/**
* | output |
* | --- |
* | "Your coach's open hours, booked in one tap." |
*
* @param {Portal_Rail_Book_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_rail_book_body = /** @type {((inputs?: Portal_Rail_Book_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Rail_Book_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_rail_book_body(inputs)
	return en_portal_rail_book_body(inputs)
});